export const LeftHandType_Precipitating = 'precipitating';
export const LeftHandType_Relieving = 'relieving';
export const LeftHandType_Attribute = 'attribute';
export const LeftHandType_Variable = 'variable';
export const LeftHandType_Atom = 'atom';
export const LeftHandType_Expression = 'expression';
export const LeftHandWithSingleId_Types = [LeftHandType_Variable, LeftHandType_Atom, LeftHandType_Expression];
export const LeftHandWithProp_Types = [LeftHandType_Relieving, LeftHandType_Precipitating, LeftHandType_Attribute];
export const FactorOperators = [LeftHandType_Precipitating, LeftHandType_Relieving];
//# sourceMappingURL=consts.js.map